import { daysFormat } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
const manageEvaluation = {
  manageEvaluation: {
    name: 'manageEvaluation',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'manageEvaluation/addManageEvaluation',
    editFun: 'manageEvaluation/editManageEvaluation',
    getListFun: 'manageEvaluation/getManageEvaluationList',
    deleteFun: 'manageEvaluation/deleteManageEvaluation',
    detailPage: [
      {
        buttonName: '新增',
        name: 'manageEvaluation',
        type: 'stepForm',
        theme: 'manageEvaluation',
        step: 'manageEvaluationInfo',
        label: '新增考评事项'
      },
      {
        buttonName: '兑换',
        name: 'manageEvaluation',
        type: 'stepForm',
        theme: 'manageEvaluation',
        step: 'manageEvaluationInfo',
        label: '积分兑换登记'
      },
      {
        buttonName: '查看',
        name: 'manageEvaluation',
        type: 'stepForm',
        theme: 'manageEvaluation',
        step: 'manageEvaluationInfo',
        label: '查看考评事项',
        checkType: 'useRowData'
      },
      {
        buttonName: '编辑',
        name: 'manageEvaluation',
        type: 'stepForm',
        theme: 'manageEvaluation',
        step: 'manageEvaluationInfo',
        label: '编辑考评事项',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增', '兑换']),
    queryParams: {
      orgUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      subjectUid: '',
      eventType: '',
      integralType: '',
      subjectName: ''
    },
    selectData: [
      {
        key: 'orgUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        clearable: false
      },
      {
        key: 'eventType',
        label: '事件类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.eventType
        }
      },
      {
        key: 'subjectUid',
        label: '考评对象',
        type: 'cascader',
        options: (params) => {
          return params.state.bidSection.unExitLaborCompanys
        },
        filterable: true,
        showAllLevels: false,
        checkStrictly: true,
        checkByValue: true,
        emitPath: false,
        placeholder: '选择机构后可获取下级人员选择'
      },
      {
        key: 'subjectName',
        label: '关键词',
        type: 'input',
        placeholder: '考评对象模糊查询'
      },
      {
        key: 'integralType',
        label: '积分类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.integralType
        }
      }
    ],
    tagInfo: (params) => {
      return (
        '共计查询到' +
        params.state.manageEvaluation.manageEvaluationList.totalSize +
        '条考评数据，合计考评分' +
        params.state.manageEvaluation.totalEvaluationScore
      )
    },
    rowData: (params) => {
      return params.state.manageEvaluation.manageEvaluationList.result
    },
    rowTotal: (params) => {
      return params.state.manageEvaluation.manageEvaluationList.totalSize
    },
    columns: [
      { label: '考评对象', prop: 'subjectName', width: '' },
      {
        label: '事件类型',
        prop: 'eventType'
      },
      {
        label: '积分类型',
        prop: 'integralType',
        tag: (params) => {
          return params.dictionarys.integralType
        },
        disabled: (params) => {
          return params.pageStatus === 'edit'
        }
      },
      {
        label: '考评得分',
        prop: 'score'
      },
      {
        label: '考评日期',
        prop: 'eventDate'
      },
      {
        label: '考评说明',
        prop: 'eventDescription',
        overflow: false,
        width: '600px'
      },
      {
        label: '操作',
        width: '220px',
        buttons: setTableButtons(['查看', '编辑', '删除'])
      }
    ],
    hasPagination: true,
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      currentSubjectScore: 0,
      subjectUid: '',
      subjectType: '',
      subjectName: '',
      eventType: '积分兑换',
      score: 0,
      eventDate: daysFormat(new Date()),
      eventDescription: '按照项目管理制度使用积分兑换奖品：'
    },
    formRules: {
      subjectUid: [
        { required: true, message: '考评对象不能为空', trigger: 'blur' }
      ],
      eventType: [
        { required: true, message: '事件类型不能为空', trigger: 'blur' }
      ],
      score: [
        {
          required: true,
          type: 'integer',
          min: -5,
          max: 5,
          message: '考评得分必填，且是-5至5之间不为0的整数数值',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.validate.validateScore
          },
          trigger: 'blur'
        }
      ],
      eventDate: [
        {
          required: true,
          message: '考评时间不可为空',
          trigger: 'blur'
        }
      ],
      eventDescription: [
        { required: true, message: '考评说明不能为空', trigger: 'blur' }
      ]
    },
    formData: {
      card: '管理考评信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'subjectUid' : null
          },
          label: '考评对象',
          type: 'cascader',
          options: (params) => {
            return params.state.bidSection.unExitLaborCompanys
          },
          filterable: true,
          showAllLevels: false,
          checkStrictly: true,
          checkByValue: true,
          emitPath: false
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' || params.pageStatus === 'edit'
              ? 'subjectName'
              : null
          },
          label: '考评对象',
          type: 'input',
          disabled: true
        },
        {
          key: 'eventType',
          label: '事件类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.eventType
          }
        },
        {
          key: 'eventDate',
          label: '考评日期',
          type: 'time'
        },
        {
          key: 'score',
          label: '考评得分',
          type: 'input',
          number: true
        },
        {
          key: 'currentSubjectScore',
          label: '累计考评分',
          type: 'input',
          disabled: true
        },
        {
          key: 'eventDescription',
          label: '考评说明',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          maxlength: 40
        }
      ]
    }
  }
}

export default manageEvaluation
